import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog-footer" }

import { ref, reactive } from "vue";
import EventsServices from "../../../services/EventsServices";
import type { FormInstance } from "element-plus";
import Decimal from "decimal.js";
import { ElNotification } from "element-plus";
import i18n from "@/core/plugins/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'AdjustPoints',
  emits: ["update"],
  setup(__props, { expose: __expose, emit: emits }) {

const t = i18n.global.t;
const ruleFormRef = ref<FormInstance>();
const dialogRef = ref(false);
const isLoading = ref(false);
const eventPartyId = ref(0);
const form = ref({
  point: 0,
  comment: "",
});

function validatePoint(rule, value, callback) {
  if (value == 0) {
    callback(new Error(t("error.adjustPointError")));
  } else {
    callback();
  }
}
const rules = reactive<any>({
  point: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "blur" },
    { validator: validatePoint, trigger: "blur" },
  ],
  comment: [
    { required: true, message: t("error.fieldIsRequired"), trigger: "blur" },
  ],
});



const submit = async () => {
  if (!ruleFormRef.value) return;

  let isValid = false;
  await ruleFormRef.value.validate(async (valid, fields) => {
    isValid = valid;
  });
  if (!isValid) return;
  isLoading.value = true;
  try {
    await EventsServices.adjustPoints({
      eventPartyId: eventPartyId.value,
      point: new Decimal(form.value.point).mul(10000).toNumber(),
      comment: form.value.comment,
    });
    emits("update");
    form.value = {
      point: 0,
      comment: "",
    };
    dialogRef.value = false;
    ElNotification({
      title: t("status.success"),
      type: "success",
    });
  } catch (error) {
    console.error(error);
    ElNotification({
      title: t("status.error"),
      type: "error",
    });
  }
  isLoading.value = false;
};

const show = (item) => {
  dialogRef.value = true;
  eventPartyId.value = item.id;
};

__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogRef.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dialogRef).value = $event)),
    title: _ctx.$t('title.adjustPoints'),
    width: "500",
    "align-center": ""
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (dialogRef.value = false)),
          disabled: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit,
          loading: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.submit")), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_el_form, {
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          model: form.value,
          rules: rules,
          "label-width": "auto"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _unref(t)('fields.points'),
              prop: "point"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: form.value.point,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.point) = $event)),
                  disabled: isLoading.value
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('fields.reason'),
              prop: "comment"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.value.comment,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.comment) = $event)),
                  disabled: isLoading.value
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})